export const filterEntitiesByIds = (entities = [], ids = []) =>
	entities.filter((entity) => ids.includes(entity._id));
